import { Button, Col, Collapse, Drawer, DrawerProps, Row, Space } from 'antd';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';

import styles from './FilterDrawer.module.css';
import FilterItem, { FilterItemProps } from './FilterItem';
import FilterSection, { FilterSectionProps } from './FilterSection';

interface FilterDrawerProps extends DrawerProps {
  onDone: () => void;
  onClear?: () => void;
  children: React.ReactNode[] | React.ReactNode;
}

const FilterDrawer = ({ onDone, onClear, children, ...props }: FilterDrawerProps) => {
  const [activeKey, setActiveKey] = useState<string[]>([]);

  const filterGroups = React.Children.map(children, (child) => {
    if (React.isValidElement(child) && child.type === FilterItem) {
      if (child.props.group) {
        return child.props.group;
      }
    }
  });

  const uniqueFilterGroups = filterGroups?.filter(
    (group, idx) => filterGroups?.indexOf(group) === idx
  );

  return (
    <Drawer
      {...props}
      className={styles.drawer}
      title="Mais filtros"
      footer={
        <Row gutter={8} justify="space-between">
          <Col>
            <Button type="primary" onClick={() => onDone()}>
              Pronto
            </Button>
          </Col>
          {onClear && (
            <Col>
              <Button type="link" onClick={() => onClear()}>
                Limpar filtros
              </Button>
            </Col>
          )}
        </Row>
      }
    >
      <Helmet>
        <title>Mais filtros | Recrutamento e Seleção</title>
      </Helmet>
      <Collapse
        ghost
        expandIconPosition="end"
        activeKey={activeKey}
        onChange={(activeKey) => setActiveKey(activeKey as string[])}
      >
        {React.Children.map(children, (child, idx) => {
          if (React.isValidElement(child) && child.type === FilterItem) {
            const { label, name, selected, ...props } = child.props;

            if (!props.group) {
              return (
                <Collapse.Panel
                  key={name}
                  header={
                    activeKey.includes(`${name}/.${idx.toString(36)}`) ? ( //WARNING: esse 36 está associado ao alfabeto, está sendo usado de base, não sabemos onde é gerado (vimos o fonte do antd e não achamos)
                      label
                    ) : (
                      <>
                        <Space direction="vertical" size="small">
                          {label}
                          {selected}
                        </Space>
                      </>
                    )
                  }
                  {...props}
                />
              );
            }
          }
          if (React.isValidElement(child) && child.type === FilterSection) {
            const { label, children, ...props } = child.props as FilterSectionProps;
            return (
              <Collapse.Panel
                key={idx}
                header={
                  activeKey.includes(`${idx}/.${idx.toString(36)}`) ? ( //WARNING: esse 36 está associado ao alfabeto, está sendo usado de base, não sabemos onde é gerado (vimos o fonte do antd e não achamos)
                    label
                  ) : (
                    <>
                      <Space direction="vertical" size="small">
                        {label}
                      </Space>
                    </>
                  )
                }
                {...props}
              >
                <Space direction="vertical" style={{ marginLeft: 5 }}>
                  {React.Children.map(children, (child) => {
                    if (React.isValidElement(child) && child.type === FilterItem) {
                      const { label, hideSelected, children, selected, ...props } =
                        child.props as FilterItemProps;

                      return (
                        <>
                          <Space direction="vertical" size="small" {...props}>
                            {label}
                            {hideSelected ? null : selected}
                            {children}
                          </Space>
                        </>
                      );
                    }

                    return null;
                  })}
                </Space>
              </Collapse.Panel>
            );
          }

          return null;
        })}
        {uniqueFilterGroups &&
          uniqueFilterGroups.map((group) => {
            return (
              <Collapse.Panel key={group} header={group}>
                <Collapse
                  ghost
                  expandIconPosition="end"
                  activeKey={activeKey}
                  onChange={(activeKey) => setActiveKey(activeKey as string[])}
                >
                  {React.Children.map(children, (child, idx) => {
                    if (React.isValidElement(child) && child.type === FilterItem) {
                      const { label, selected, ...props } = child.props;

                      if (props.group === group) {
                        return (
                          <Collapse.Panel
                            key={group}
                            header={
                              activeKey.includes(`${group}/.${idx.toString(36)}`) ? ( //WARNING: esse 36 está associado ao alfabeto, está sendo usado de base, não sabemos onde é gerado (vimos o fonte do antd e não achamos)
                                label
                              ) : (
                                <>
                                  <Space direction="vertical" size="small">
                                    {label}
                                    {selected}
                                  </Space>
                                </>
                              )
                            }
                            {...props}
                          />
                        );
                      }
                    }
                  })}
                </Collapse>
              </Collapse.Panel>
            );
          })}
      </Collapse>
    </Drawer>
  );
};

export default FilterDrawer;
